export const CUCUMBER_NAME = '/cucumber_report.html';
export const USER_CREATION_NAME = '/created_users.txt';
export const API_NAME = '/app.log';
export const SCHEDULED_USER_CREATION = 'scheduled_user_creation';
export const SCHEDULED_API = 'scheduled_api_alm';
export const STATUSES_WITH_LOGS = ['SUCCEEDED', 'FAILED'];
export const STATUSES_ON_GOING = ['SUBMITTED', 'PENDING', 'RUNNABLE', 'STARTING', 'RUNNING'];
export const JOB_NAME_USER = 'user';
export const JOB_NAME_CREATION = 'creation';
